<template>
  <div>
    <input
      type="file"
      style="display: none"
      ref="image"
      accept="image/*"
      multiple
      @change="onFilePicked"
      >
    <v-btn
      :color="color"
      dark
      large
      v-on:click.prevent="pickFile()"
      >{{ caption }}</v-btn>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    props: {
      color: {
          type: String,
          default: 'blue'
      },
      caption: {
          type: String,
          default: ''
      },
    },
    data: function () {
      return {
          imageName: '',
          imageFile: [],
      }
    },
    computed: {
      ...mapState({
          api_url: state => state.api_url,
      }),
    },
    methods: {
      pickFile () {
        this.$refs.image.click ()
      },
      onFilePicked (e) {
        const files = e.target.files
        if(files[0] !== undefined) {
          this.imageName = files[0].name
          if(this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          var i, j = 0;
          let formData = new FormData();         
          for (i = 0; i < files.length; i++) {
            const fr = new FileReader ();
            fr.readAsDataURL(files[i]);
            fr.addEventListener('load', () => {
              formData.append('fileToUpload' + j, files[j]);
              if(j == files.length - 1) {
                this.$http.post(this.api_url + 'upload', formData).then(result => {
                  this.$emit('files-uploaded', result.body.files);
                });
              }
              j++;
            })
          }
          
        } else {
          this.imageName = ''
          this.imageFile = []
        }
      },
    }
  }
</script>

<style>

</style>
